export const FISCAL_PERMISSIONS = {
  dashboardRead: 'fiscal.read',
  documentCreate: 'fiscal.documents.create',
  documentUpdate: 'fiscal.documents.update',
  documentCancel: 'fiscal.documents.cancel',
  configManage: 'fiscal.config.manage',
  integrationSync: 'fiscal.integration.sync',
} as const;
